var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",on:{"click":_vm.handleClick}},[_c('v-checkbox',{staticClass:"mt-0 pt-0",attrs:{"hide-details":"","input-value":_vm.inputValue}}),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }